import ScrollSpy from "react-scrollspy-navigation";
import DLink from "./DLink"
import { useMatch, useResolvedPath, useNavigate } from "react-router";

export default function CentralLink({ projects, to, children, className, ...props}) {
    const projectsPage = useMatch({path:useResolvedPath("/projects/").pathname, end:true});
    let navigate = useNavigate();
    if (projectsPage) {
        return (
            <ScrollSpy activeClass="navbar-vis" onClickEach={()=>{navigate("/")}}>
                {projects.map(project=>(
                    <a key={"NAV-"+project.ProjectID} className={className+" navbar-invis"} href={"#"+project.ProjectID} {...props}>{project.ProjectName}</a>
                ))}
            </ScrollSpy>
        )
    }
    return (
        <DLink className={className} to={to} {...props}>{children}</DLink>
    )
}